// The routes that show one loan's file, and the segment that carries its number. A loan
// number is always digits, which is also what keeps `/loan_process/structure/new` out.
const loanFilePaths = [
  /^\/loan_process\/[^/]+\/(\d+)\/?$/,
  /^\/servicing\/(\d+)\/?$/,
  /^\/configurablePage\/[^/]+(?:\/[^/]+)?\/(\d+)\/?$/,
]

/** The loan whose file this route shows, or null when the route is not a loan file. */
export const loanNumberForPath = (pathname: string) => {
  for (const path of loanFilePaths) {
    const match = pathname.match(path)
    if (match) return match[1]
  }
  return null
}
